import G6 from '../index';
import {shapeTypeConst} from '../../conf';
import {getIdStr} from '../../data';


/**
 * 拓扑插件-边相关逻辑
 */


/**
 * 拓扑插件-边-计算边位置信息和曲线，防止边重叠
 * @param that vue 实例
 */
export function computeEdgePoints(that) {
  const stage = that.getCanvasStage();
  const edgeArray = stage?.save()?.edges;

  if (edgeArray && edgeArray.length > 0) {
    G6.Util.processParallelEdges(edgeArray);
    stage.getEdges().forEach((edge, i) => {
      const id = getIdStr();
      stage.updateItem(edge, {
        curveOffset: edgeArray[i].curveOffset,
        curvePosition: edgeArray[i].curvePosition,
        id,
        type: shapeTypeConst.quadraticCircleRunning,
        idField: id,
        tpId: that.getTpId()
      });
    });
  }
}


/**
 * 拓扑插件-边-添加初始化参数
 * @param model 边参数
 */
export function addInitConfig(model) {
  if (!model) {
    return {};
  }

  const edgeModel = {id: getIdStr()};
  edgeModel.style = {
    ...model.style,
    opacity: 1,
    lineDash: [],
    shadowBlur: 0,
    strokeOpacity: 1,
    shadowOffsetX: 0,
    shadowOffsetY: 0
  };
  
  const labelStyle = {
    ...model?.labelCfg?.style || {},
    textAlign: 'center',
    lineWidth: 0,
    opacity: 1,
    fontSize: 14,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0
  };
  
  edgeModel.labelCfg = {
    ...model.labelCfg,
    position: 'middle',
    autoRotate: true,
    refX: 0,
    refY: 0,
    style: labelStyle
  };
  
  return edgeModel;
}
